/**
 * @generated SignedSource<<d3051a35a7ddb3bd5e479c576b338039>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type pricingGuidanceTracking_item$data = {
  readonly pricingGuidance: {
    readonly medianAmount: {
      readonly amount: number | null;
    } | null;
    readonly price: {
      readonly amount: number | null;
    } | null;
  } | null;
  readonly " $fragmentType": "pricingGuidanceTracking_item";
};
export type pricingGuidanceTracking_item$key = {
  readonly " $data"?: pricingGuidanceTracking_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"pricingGuidanceTracking_item">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "pricingGuidanceTracking_item"
};

(node as any).hash = "2f6bce3762cc2c51d56edaa431f5d4e2";

export default node;
